export const corRodape = "#4e4d0a"
export const corSecundaria = "#FFFFFF"
export const backgroundColor = "#87850f"
export const corVerde = "#35E01C"
export const corVermelho = "#DE4228"
export const font = "'Crimson Text', serif"
export const fontSecundaria = "'Bebas Neue', sans-serif;"
